document.addEventListener('DOMContentLoaded', function () {
  (function () {
    var root = document.getElementById('AdventCalendarRoot');
    if (!root) return;

    var calendar = root.querySelector('[data-advent-calendar]');
    var tiles = root.querySelectorAll('.advent-tile');
    var modal = root.querySelector('[data-advent-modal]');
    if (!calendar || !modal) return;

    var overlay = modal.querySelector('[data-advent-modal-overlay]');
    var closeBtn = modal.querySelector('[data-advent-modal-close]');

    var dayNumberEl = modal.querySelector('[data-advent-modal-day-number]');
    var dateEl = modal.querySelector('[data-advent-modal-date]');
    var imgEl = modal.querySelector('[data-advent-modal-image]');
    var headlineEl = modal.querySelector('[data-advent-modal-headline]');
    var descEl = modal.querySelector('[data-advent-modal-description]');
    var ctaEl = modal.querySelector('[data-advent-modal-cta]');
    var ctaLabelEl = modal.querySelector('[data-advent-modal-cta-label]');
    var discountEl = modal.querySelector('[data-advent-modal-discount]');
    var termsEl = modal.querySelector('[data-advent-modal-terms]');

    // Today (for locking future days)
    var today = new Date();
    var todayDay = today.getDate(); // 1–31

    // Always show calendar now that the gate is removed
    root.classList.add('advent-root--show-calendar');

    function initTiles() {
      tiles.forEach(function (tile) {
        var day = parseInt(tile.getAttribute('data-day'), 10);
        var expired = tile.getAttribute('data-expired') === 'true';

        var isFuture = day > todayDay;
        var isLocked = isFuture || expired;

        tile.dataset.locked = isLocked ? 'true' : 'false';

        if (isLocked) {
          tile.classList.add('advent-tile--locked');
        } else {
          tile.classList.add('advent-tile--available');
        }

        if (day === todayDay && !expired) {
          tile.classList.add('advent-tile--today');
        }

        tile.addEventListener('click', function () {
          if (tile.dataset.locked === 'true') return;
          openModalFromTile(tile);
        });
      });
    }

    function openModalFromTile(tile) {
      var day = tile.getAttribute('data-day');
      var expired = tile.getAttribute('data-expired') === 'true';
      if (expired) return;

      var headline = tile.getAttribute('data-headline') || '';
      var dateLabel = tile.getAttribute('data-date-label') || '';
      var description = tile.getAttribute('data-description') || '';
      var image = tile.getAttribute('data-image') || '';
      var buttonLabel = tile.getAttribute('data-button-label') || 'Shop now';
      var buttonLink = tile.getAttribute('data-button-link') || '#';
      var discountCode = tile.getAttribute('data-discount-code') || '';
      var terms = tile.getAttribute('data-terms') || '';

      if (dayNumberEl) dayNumberEl.textContent = day;
      if (dateEl) dateEl.textContent = dateLabel;
      if (headlineEl) headlineEl.textContent = headline;
      if (descEl) descEl.textContent = description;
      if (ctaLabelEl) ctaLabelEl.textContent = buttonLabel;
      if (ctaEl) ctaEl.setAttribute('href', buttonLink || '#');

      if (imgEl) {
        if (image) {
          imgEl.src = image;
          imgEl.style.display = 'block';
        } else {
          imgEl.removeAttribute('src');
          imgEl.style.display = 'none';
        }
      }

      var discountWrapper = modal.querySelector('[data-advent-modal-discount-wrapper]');

      if (discountWrapper && discountEl) {
        if (discountCode && discountCode.trim() !== '') {
          discountEl.textContent = discountCode;
          discountWrapper.style.display = 'block';
        } else {
          discountWrapper.style.display = 'none';
        }
      }

      if (termsEl) termsEl.textContent = terms;

      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('advent-modal--open');
      document.documentElement.classList.add('advent-modal-open');
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('advent-modal--open');
      document.documentElement.classList.remove('advent-modal-open');
    }

    function initModal() {
      if (!modal) return;

      if (overlay) overlay.addEventListener('click', closeModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    }

    // Init everything (no gate anymore)
    initTiles();
    initModal();
  })();
});
